import { render, staticRenderFns } from "./AgendamentosTodos.vue?vue&type=template&id=5b1761df"
import script from "./AgendamentosTodos.vue?vue&type=script&lang=js"
export * from "./AgendamentosTodos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports